import React, { useEffect } from 'react';
import { Card, Container, Column, Media, Title, Tag, Content } from 'rbx';
import { Redirect } from 'react-router-dom';
import AppService from '../../../services/app';
import moment from 'moment';
import {
  cpfOrCnpjMask,
  dateMask,
  celPhoneMask,
  placaMask,
} from '../../../commons/masks';
import Timer from '../../components/Timer';

const AppDetail = () => {
  let app = JSON.parse(sessionStorage.getItem('app'));
  let vehiclesParked =
    JSON.parse(sessionStorage.getItem('vehiclesParked')) || [];

  useEffect(() => {
    fetchVehiclesParked();
  }, []);

  useEffect(() => {
    loadDataUserApp();
  }, [sessionStorage.getItem('app')]);

  if (!app) return <Redirect to={{ pathname: '/dashbord' }} />;

  const loadDataUserApp = async () => {
    app = await JSON.parse(sessionStorage.getItem('app'));
  };

  const fetchVehiclesParked = async () => {
    try {
      await AppService.vehiclesParked(app.cpf_cnpj, true);
      vehiclesParked =
        JSON.parse(sessionStorage.getItem('vehiclesParked')) || [];
    } catch (e) {
      if (e.response)
        console.log(`${e.response.status}: ${e.response.data.errors}`);
      else console.log(e.message);
    }
  };

  return (
    <Card>
      {app && (
        <>
          <Card.Header>
            <Card.Header.Title>
              <Container>
                <Column.Group breakpoint="mobile">
                  <Column size={7}>Ficha Técnica</Column>
                  <Column>
                    <Tag.Group gapless style={{ justifyContent: 'right' }}>
                      <Tag color="dark">Usuário</Tag>
                      <Tag color="info">
                        {app['role'] ? app['role'].toUpperCase() : 'App'}
                      </Tag>
                    </Tag.Group>
                  </Column>
                </Column.Group>
              </Container>
            </Card.Header.Title>
          </Card.Header>
          <Card.Content>
            <Media>
              <Media.Item>
                <Title size={5}>{app.name}</Title>
              </Media.Item>
            </Media>
            <Content>
              <p>CPF/CNPJ: {cpfOrCnpjMask(app.cpf_cnpj)}</p>
              <p>Fone: {celPhoneMask(app.phone)}</p>
              <p>Email: {app.email}</p>
              <p>Nascido em: {dateMask(app.birthday)}</p>
              <p>Cliente desde: {moment(app.createdAt).format('DD/MM/YYYY')}</p>
              <hr />
              <p>CADs disponíveis: {app.cads}</p>
              <hr />
              <p>
                Veículos: {app.vehicles.length} / Estacionados:{' '}
                {vehiclesParked.length}
              </p>
              <ul>
                {app.vehicles.map((licensePlate, index) => (
                  <li>
                    <Column.Group breakpoint="mobile" vcentered>
                      <Column size={4} style={{ paddingBottom: '0.1rem' }}>
                        {placaMask(licensePlate)}
                      </Column>
                      <Column style={{ paddingBottom: '0.1rem' }}>
                        {vehiclesParked.map(
                          (parked) =>
                            parked.licensePlate === licensePlate && (
                              <>
                                <Tag
                                  className="ml-2"
                                  color="custom-purple"
                                  size="medium"
                                >
                                  <Timer
                                    startDate={parked.date_started}
                                    paidMinutes={parked.time_paid}
                                    reverse={false}
                                  />
                                </Tag>
                                <Tag
                                  className="ml-2"
                                  color="custom-purple"
                                  size="medium"
                                >
                                  <Timer
                                    startDate={parked.date_started}
                                    paidMinutes={parked.time_paid}
                                    reverse={true}
                                  />
                                </Tag>
                              </>
                            ),
                        )}
                      </Column>
                    </Column.Group>
                  </li>
                ))}
              </ul>
            </Content>
          </Card.Content>
        </>
      )}
    </Card>
  );
};

export default AppDetail;
